import React from 'react';
import styled from 'styled-components';

import type { ChartColor } from '../../types';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;

  background: #fff;
  border-radius: 8px;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;

  border-bottom: 1px solid #e5e7eb;
`;

const ModalBody = styled.div`
  max-height: 500px;
  padding: 16px 24px;
  overflow-y: auto;
`;

const CloseButton = styled.button`
  color: #6b7280;
  font-size: 24px;

  background: none;
  border: 0;
  cursor: pointer;

  &:hover {
    color: #374151;
  }
`;

const List = styled.ul`
  margin: 0;
  padding: 4px 0;

  text-align: right;

  list-style-type: none;
`;

const ListItem = styled.li`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  padding-left: 0;

  font-size: 14px;
  line-height: 24px;

  border-bottom: 1px solid #e5e7eb;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    border-bottom: 0;
  }
`;

const LegendItemContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

type LegendColorProps = {
  itemColor?: string;
};

export const LegendColor = styled.div<LegendColorProps>`
  width: 16px;
  height: 16px;

  background-color: ${({ itemColor }) => itemColor || '#9CA3AF'};
  border-radius: 2px;
`;

const Text = styled.p`
  margin: 12px 0;

  color: #111827;
`;

const Title = styled.h2`
  margin: 0;

  color: #111827;
  font-weight: bold;
  font-size: 20px;
`;

type ChartLegendProps = {
  open: boolean;
  onClose: () => void;
  chartColors: ChartColor[];
  labels: string[];
};

export const ChartLegend = ({ open, onClose, chartColors, labels }: ChartLegendProps) => {
  if (!open) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <Title>Legend</Title>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <List>
            {labels.map((label, idx) => (
              <ListItem key={label}>
                <LegendItemContainer>
                  <LegendColor itemColor={chartColors[idx % chartColors.length].default} />
                  <Text>{label}</Text>
                </LegendItemContainer>
              </ListItem>
            ))}
          </List>
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};
